export function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function randomItem(array) {
    if (!array.length)
        return;
    return array[random(0, array.length - 1)];
}
